/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable semi */
import Breadcrumbs from 'Base/components/Common/Breadcrumb';
import React, { Component } from 'react';
import { MetaTags } from 'react-meta-tags';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { Link } from 'react-router-dom';
import { CSVLink } from 'react-csv';
import Papa from 'papaparse';
import Result from 'iotera-base/result';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  FormGroup,
  ModalBody,
  Modal,
  ModalHeader,
  Form,
  Input,
  ModalFooter,
} from 'reactstrap';
import { safeDeepGet, safeDeepSet } from 'iotera-base/utility/json';
import { isNumber } from 'iotera-base/utility/object';
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from 'react-bootstrap-table2-paginator';
import { connect } from 'react-redux';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import {
  list,
  list_balance,
  toggleRefund,
  manualUpdate,
  addProjectHandle,
  toggleMultiBalance,
  getDownloadConfig,
  setDownloadConfig,
} from '../../store/Mapping/actions';
import {
  AvForm,
  AvField,
  AvGroup,
  AvInput,
} from 'availity-reactstrap-validation';
import {
  create,
  importProduct,
  getNotification,
  updateNotification,
} from '../../store/Project/actions';
import { keys } from 'lodash';
import { set_price_subs } from '../../store/business-point-fee/actions';
import SettingsModal from './Component/SettingModal';
import SampleJsonModal from './Component/SampleModal';
class ProjectList extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      modal: false,
      modalPrice: false,
      modalProduct: false,
      modalProjectHandle: false,
      modalNotification: false,
      modalFlag: false,
      modalConfig: false,
      showSettingsModal: false,
      selectedRow: {},
      showJsonModal: false,
      formData: {
        multiBalance: false,
        shareLandlord: false,
        shareBalance: false,
        withHours: false,
        typeCMS: '',
      },
      configDownload: [],
      isLoading: false,
      rows1: [],
      list: [],
      ProjectListColumns: [
        {
          text: 'id',
          dataField: 'id',
          sort: true,
          headerStyle: { fontSize: '10px' },
          hidden: true,
          formatter: (cellContent, row) => (
            <p className="font-size-10">{row.id}</p>
          ),
        },
        {
          text: 'App ID',
          dataField: 'appid',
          headerStyle: { fontSize: '10px' },
          sort: true,
          editable: false,
          headerAlign: (column, colIndex) => 'center',
          align: 'center',
          formatter: (cellContent, row) => (
            <p className="font-size-10">{'100000' + row.appid}</p>
          ),
        },
        {
          text: 'Application Name',
          dataField: 'name',
          sort: true,
          editable: false,
          headerStyle: { fontSize: '10px' },
          headerAlign: (column, colIndex) => 'center',
          align: 'center',
          formatter: (cellContent, row) => (
            <>
              <h5 className="font-size-10 mb-1">
                <Link
                  to="#"
                  className="text-dark"
                  onClick={() => window.open(safeDeepGet(row, 'url_cms', ''))}
                >
                  {row.name}
                </Link>
              </h5>
              <h5 className=" font-size-10 mb-1">
                <Link to="#" className="text-dark">
                  Multitenancy {safeDeepGet(row, 'multitenancy_id', '')}
                </Link>
              </h5>
            </>
          ),
        },
        {
          text: 'Balance',
          dataField: 'balance',
          headerAlign: (column, colIndex) => 'center',
          align: 'center',
          headerStyle: { fontSize: '10px' },

          sort: true,
          editable: false,
          formatter: (cellContent, row) => (
            <>
              <p
                className=" font-size-10 mb-2"
                style={{
                  textAlign: 'right',
                  color:
                    Number(safeDeepGet(row, 'balance', 0)) < 0
                      ? 'red'
                      : 'black',
                }}
              >
                {row.balance != 'Loading....'
                  ? 'Rp. ' +
                    Number(safeDeepGet(row, 'balance', 0))
                      .toFixed(2)
                      .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') +
                    ',-'
                  : safeDeepGet(row, 'balance', 0)}
              </p>
              <p
                className=" font-size-10 mb-0"
                style={{
                  textAlign: 'right',
                  color: 'black',
                }}
              >
                {'Latest Update: ' +
                  this.handleTime(safeDeepGet(row, 'commit_point', 0))}
              </p>
            </>
          ),
        },
        {
          text: 'Setting',
          headerAlign: (column, colIndex) => 'center',
          align: 'center',
          headerStyle: { fontSize: '10px' },
          editable: false,
          formatter: (cellContent, row) => (
            <>
              <Button color="primary" onClick={() => this.toggleFlag(row)}>
                Edit Settings
              </Button>
            </>
          ),
        },
        {
          text: 'Config Download',
          headerAlign: (column, colIndex) => 'center',
          align: 'center',
          headerStyle: { fontSize: '10px' },
          editable: false,
          formatter: (cellContent, row) => (
            <>
              <Button color="primary" onClick={() => this.handleConfig(row)}>
                Edit Config
              </Button>
            </>
          ),
        },
        // {
        //   text: 'Subscription Price',
        //   dataField: 'price',
        //   editable: false,
        //   headerAlign: (column, colIndex) => 'center',
        //   align: 'center',
        // headerStyle: { fontSize: '10px' },

        //   sort: true,
        //   formatter: (cellContent, row) => (
        //     <>
        //       <p
        //         className="mb-2"
        //         style={{
        //           textAlign: 'right',
        //           color:
        //             Number(safeDeepGet(row, 'price', 0)) < 0 ? 'red' : 'black',
        //         }}
        //       >
        //         {'Rp. ' +
        //           Number(safeDeepGet(row, 'price', 0))
        //             .toFixed(2)
        //             .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') +
        //           ',-'}
        //       </p>
        //     </>
        //   ),
        // },
        {
          dataField: 'manualUpdate',
          text: 'Update Balance',
          isDummyField: true,
          editable: false,
          headerAlign: (column, colIndex) => 'center',
          align: 'center',
          headerStyle: { fontSize: '10px' },
          formatter: (cellContent, row) => (
            <>
              <Button
                className="btn btn-primary white"
                onClick={() => this.handleManualUpdateBalance(row)}
              >
                Update
              </Button>
            </>
          ),
        },
        {
          dataField: 'action',
          isDummyField: true,
          editable: false,
          align: 'center',
          headerStyle: { fontSize: '10px' },

          text: 'Action',
          headerAlign: (column, colIndex) => 'center',
          formatter: (cellContent, data) => (
            <div className="d-flex gap-3">
              <Tippy content={'User'}>
                <Link className="text-success" to="#">
                  <i
                    className="mdi mdi-account font-size-18"
                    id="edittooltip"
                    onClick={() => this.handleUserClick(data)}
                  ></i>
                </Link>
              </Tippy>
              <Tippy content={'Device'}>
                <Link className="text-success" to="#">
                  <i
                    className="mdi mdi-devices font-size-18"
                    id="edittooltip"
                    onClick={() => this.handleDeviceClick(data)}
                  ></i>
                </Link>
              </Tippy>
              <Tippy content={'Tags'}>
                <Link className="text-success" to="#">
                  <i
                    className="mdi mdi-tag font-size-18"
                    id="edittooltip"
                    onClick={() => this.handleTagClick(data)}
                  ></i>
                </Link>
              </Tippy>
              <Tippy content={'Graph'}>
                <Link className="text-success" to="#">
                  <i
                    className="mdi mdi-chart-box font-size-18"
                    id="edittooltip"
                    onClick={() => this.handleGraphClick(data)}
                  ></i>
                </Link>
              </Tippy>
              <Tippy content={'Summary'}>
                <Link className="text-success" to="#">
                  <i
                    className="mdi mdi-microsoft-excel font-size-18"
                    id="edittooltip"
                    onClick={() => this.handleSummaryClick(data)}
                  ></i>
                </Link>
              </Tippy>
              <Tippy content={'Price'}>
                <Link className="text-info" to="#">
                  <i
                    className="mdi mdi-bank font-size-18"
                    id="edittooltip"
                    onClick={() => this.handleChangePrice(data)}
                  ></i>
                </Link>
              </Tippy>
              <Tippy content={'Upload Product'}>
                <Link className="text-success" to="#">
                  <i
                    className="mdi mdi-package font-size-18"
                    id="edittooltip"
                    onClick={() => this.handlePushProduct(data)}
                  ></i>
                </Link>
              </Tippy>
              <Tippy content={'Download CSV'}>
                <Link className="text-success" to="#">
                  <i
                    className="mdi mdi-download font-size-18"
                    id="edittooltip"
                    onClick={() => this.handleDonloadClick(data)}
                  ></i>
                </Link>
              </Tippy>
            </div>
          ),
        },
      ],
    };
    this.handleValidSubmitPrice = this.handleValidSubmitPrice.bind(this);
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
    this.handleValidSubmitNotification =
      this.handleValidSubmitNotification.bind(this);
    this.handleValidProjectHandle = this.handleValidProjectHandle.bind(this);
    this.handleImportClick = this.handleImportClick.bind(this);
    this.handleAddProjectHandle = this.handleAddProjectHandle.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitProduct = this.handleSubmitProduct.bind(this);
    this.handleGraphClick = this.handleGraphClick.bind(this);
    this.handleSummaryClick = this.handleSummaryClick.bind(this);
    this.handleChangePrice = this.handleChangePrice.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.toggleConfig = this.toggleConfig.bind(this);
    this.toggleFlag = this.toggleFlag.bind(this);
    this.toggleDetail = this.toggleDetail.bind(this);
    this.toggleNotification = this.toggleNotification.bind(this);
    this.toggleProduct = this.toggleProduct.bind(this);
    this.handleUserClick = this.handleUserClick.bind(this);
    this.handleDeviceClick = this.handleDeviceClick.bind(this);
    this.handleTagClick = this.handleTagClick.bind(this);
    this.handleDonloadClick = this.handleDonloadClick.bind(this);
    this.togglePrice = this.togglePrice.bind(this);
    this.afterSaveCell = this.afterSaveCell.bind(this);
    this.handleTime = this.handleTime.bind(this);
    this.handlePushProduct = this.handlePushProduct.bind(this);
    this.handleManualUpdateBalance = this.handleManualUpdateBalance.bind(this);
    this.handleOnChangeProduct = this.handleOnChangeProduct.bind(this);
    this.handleAddRow = this.handleAddRow.bind(this);
    this.handleRemoveRow = this.handleRemoveRow.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.closeFlag = this.closeFlag.bind(this);
  }

  handleChange = e => {
    const { name, type, checked, value } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [name]: type === 'checkbox' ? checked : value,
      },
    }));
  };

  handleTime(time) {
    const date1 = new Date(time).toLocaleDateString('en-GB');
    const time1 = new Date(time).toLocaleTimeString('en-GB');
    return date1 + ' ' + time1;
  }
  componentDidMount() {
    this.props.GetNotification();
    this.props.MappList();
  }
  handlePushProduct = application => {
    this.toggleProduct();
    this.setState({ application });
  };
  handleChangePrice = row => {
    this.setState({
      applicationID: '100000' + row.id,
      appId: row.id,
      price_subs: row.price,
    });
    this.togglePrice();
  };
  closeFlag(){
    this.setState(prevState => ({
      modalFlag: false,
    }))
  }
  toggleFlag(row) {
    this.setState(prevState => ({
      modalFlag: !prevState.modalFlag,
      // isEdit: !prevState.isEdit,
      row,
      formData: {
        autoRefund: JSON.parse(row.autoRefund || false),
        multiBalance: JSON.parse(row.multiBalance || false),
        shareLandlord: JSON.parse(row.shareLandlord || false),
        withHours: JSON.parse(row.withHours || false),
        shareBalance: JSON.parse(row.shareBalance || false),
        typeCMS: row.typeCMS || '',
      },
    }));
  }
  toggleConfig(row) {
    this.setState(prevState => ({
      modalConfig: !prevState.modalConfig,
      // isEdit: !prevState.isEdit,
    }));
  }
  handleConfig(row) {
    let url = safeDeepGet(row, 'url_balance', '');
    if (url.includes('https')) {
      url = url.replace('getBalances', 'downloadConfig');
    }
    const payload = {
      url,
      app_id: safeDeepGet(row, 'id', ''),
      multitenancy: safeDeepGet(row, 'multitenancy', false),
    };
    this.setState({ selectedRow: row });
    // console.log(payload)
    this.props.GetDownload(payload);
  }
  toggleProduct() {
    this.setState(prevState => ({
      modalProduct: !prevState.modalProduct,
      // isEdit: !prevState.isEdit,
    }));
  }
  toggleNotification() {
    this.setState(prevState => ({
      modalNotification: !prevState.modalNotification,
      // isEdit: !prevState.isEdit,
    }));
  }

  togglePrice() {
    this.setState(prevState => ({
      modalPrice: !prevState.modalPrice,
      // isEdit: !prevState.isEdit,
    }));
  }
  handleValidSubmitPrice(event, values) {
    const { appId } = this.state;
    const price_subs = Number(values.price_subs);
    const submittedValues = {
      appId,
      price_subs,
    };
    this.props.UpdatePrice(submittedValues);
  }
  handleValidProjectHandle(event, values) {
    this.props.AddProjectHandle(values);
  }
  handleValidSubmitNotification(event, values) {
    this.props.PushNotification(values);
  }

  handleValidSubmit = (event, values) => {
    const { autoRefund, multiBalance, shareLandlord, shareBalance, typeCMS, withHours } =
      this.state.formData;
    const { row } = this.state;

    const url_toggle_auto = safeDeepGet(row, 'url_toggle_auto_refund', '');
    const url_cms = safeDeepGet(row, 'url_cms', '');
    const multitenancy = safeDeepGet(row, 'multitenancy', '');
    const app_id = safeDeepGet(row, 'appid', safeDeepGet(row, 'id', ''));
    const subdomain = url_cms.split('//')[1].split('.')[0];

    // 🔁 1. Request khusus autoRefund
    if (url_toggle_auto !== '') {
      const payloadAutoRefund = {
        url: url_toggle_auto,
        application_id: '100000' + app_id,
        multitenancy,
        active: autoRefund,
        key: 'auto_refund',
      };
      this.props.ToogleRefund(payloadAutoRefund);
    }

    // 🔁 2. Semua setting lain digabung ke setMultiBalance
    const payloadMulti = {
      url: 'https://asia-southeast2-iotera-vending-multitenancy.cloudfunctions.net/setMultiBalance',
      application_id: '100000' + app_id,
      multitenancy,
      domain: subdomain,
      data: {
        isMultiBalance: multiBalance,
        type: typeCMS,
        shareLandlord,
        shareBalance,
        withHours
      },
    };
    this.props.ToggleMulti(payloadMulti);
  };

  handleInputChange = (e, idx) => {
    const { name, value } = e.target;
    const { configDownload } = this.state;

    const updatedConfig = [...configDownload];
    updatedConfig[idx][name] = value;

    this.setState({ configDownload: updatedConfig });
  };

 
  handleConfigSubmit = (event, values) => {
    const { selectedRow, configDownload } = this.state;
    let url = safeDeepGet(selectedRow, 'url_balance', '');
    if (url.includes('https')) {
      url = url.replace('getBalances', 'downloadConfig');
    }

    const cleanedData = configDownload.map(item => {
      const cleanedItem = {};
      Object.entries(item).forEach(([key, value]) => {
        if (value !== ' ' && value !== '') {
          cleanedItem[key] = value;
        }
      });
      return cleanedItem;
    });
    const payload = {
      data: cleanedData,
      application_id: "100000"+selectedRow.id,
      multitenancy: selectedRow.multitenancy,
      url
    };
    this.props.SetDownload(payload);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.addResult !== prevProps.addResult) {
      // Success create
      const code = safeDeepGet(
        this.props,
        ['addResult', 'code'],
        Result.UNKNOWN_ERROR
      );

      if (code === Result.SUCCESS) {
        this.showToast('Project');
        this.handleAddProjectHandle();
        this.props.MappList();
      } else if (code === Result.FAILED) {
        this.showToastFailed('Gagal Tambah Project');
        this.props.MappList();
      }
    }
    if (this.props.createResult !== prevProps.createResult) {
      // Success create
      const code = safeDeepGet(
        this.props,
        ['createResult', 'code'],
        Result.UNKNOWN_ERROR
      );

      if (code === Result.SUCCESS) {
        this.showToast('Project');
        this.toggleDetail();
      } else if (code === Result.FAILED) {
        this.showToastFailed();
        this.props.MappList('Gagal Tambah Project');
      }
    }
    if (this.props.productResult !== prevProps.productResult) {
      // Success create
      const code = safeDeepGet(
        this.props,
        ['productResult', 'code'],
        Result.UNKNOWN_ERROR
      );

      if (code === Result.SUCCESS || code === Result.HTTP.OK) {
        this.showToast('Product');
        this.toggleProduct();
        this.setState({ productArray: [], isLoading: false });
      } else if (code === Result.FAILED) {
        this.showToastFailed('Gagal Tambah Product');
        this.setState({ isLoading: false });
      }
    }
    if (this.props.result !== prevProps.result) {
      const list = safeDeepGet(this.props, ['result', 'body'], []);
      if (list.length > 0) {
        this.props.BalanceList();
        this.setState({ list });
      }
    }
    if (this.props.balance_result !== prevProps.balance_result) {
      const list = safeDeepGet(this.props, ['balance_result', 'body'], []);
      if (list.length > 0) {
        this.setState({ list });
      }
    }

    if (this.props.setPriceResult !== prevProps.setPriceResult) {
      const code = safeDeepGet(
        this.props,
        ['setPriceResult', 'code'],
        Result.UNKNOWN_ERROR
      );
      if (code === Result.SUCCESS) {
        this.togglePrice();
        // this.props.MappList();
        this.props.BalanceList();
      }
    }
    if (this.props.toggleResult !== prevProps.toggleResult) {
      const code = safeDeepGet(
        this.props,
        ['toggleResult', 'code'],
        Result.UNKNOWN_ERROR
      );
      if (code === Result.SUCCESS || code === Result.HTTP.OK) {
        this.showToastToggle('Auto Refund');
      } else if (code === Result.FAILED) {
        this.showToastFailedToggle('Auto Refund');
      }
    }
    if (this.props.getDownloadResult !== prevProps.getDownloadResult) {
      const code = safeDeepGet(
        this.props,
        ['getDownloadResult', 'code'],
        Result.UNKNOWN_ERROR
      );
      if (code === Result.SUCCESS || code === Result.HTTP.OK) {
        const body = safeDeepGet(this.props, ['getDownloadResult', 'body'], []);
        const configDownload = [];
        for (const i in body) {
          const data = body[i];
          const row = safeDeepGet(data, 'row', ' ');
          const key = safeDeepGet(data, 'key', ' ');
          const from = safeDeepGet(data, 'from', ' ');
          const format = safeDeepGet(data, 'format', ' ');
          const sdefault = safeDeepGet(data, 'default', ' ');
          const fallback = safeDeepGet(data, 'fallback', ' ');
          const condition = safeDeepGet(data, 'condition', ' ');
          configDownload.push({
            row,
            key,
            from,
            format,
            default: sdefault,
            fallback,
            condition,
          });
        }
        this.setState({
          configDownload,
        });
        this.toggleConfig();
      } else if (code === Result.FAILED) {
        this.showToastFailed('Failed to get config data');
      }
    }
    if (this.props.toggleMultiResult !== prevProps.toggleMultiResult) {
      const code = safeDeepGet(
        this.props,
        ['toggleMultiResult', 'code'],
        Result.UNKNOWN_ERROR
      );
      console.log(code)
      if (code === Result.SUCCESS || code === Result.HTTP.OK) {
        this.props.BalanceList();
        this.showToastToggle('Setting Multitenancy');
        this.closeFlag({});
      } else if (code === Result.FAILED) {
        this.showToastFailedToggle('Setting Multitenancy');
      }
    }
    if (this.props.setDownloadResult !== prevProps.setDownloadResult) {
      const code = safeDeepGet(
        this.props,
        ['setDownloadResult', 'code'],
        Result.UNKNOWN_ERROR
      );
      if (code === Result.SUCCESS || code === Result.HTTP.OK) {
        this.props.BalanceList();
        this.toggleConfig();
        this.showToastToggle('Setting Config Download');
      } else if (code === Result.FAILED) {
        this.showToastFailedToggle('Setting Config Download');
      }
    }
    if (this.props.manualResult !== prevProps.manualResult) {
      const code = safeDeepGet(
        this.props,
        ['manualResult', 'code'],
        Result.UNKNOWN_ERROR
      );
      if (code === Result.SUCCESS || code === Result.HTTP.OK) {
        this.props.BalanceList();
        this.showToastToggle();
      }
    }
    if (this.props.getNotificationResult !== prevProps.getNotificationResult) {
      // Success create
      const code = safeDeepGet(
        this.props,
        ['getNotificationResult', 'code'],
        Result.UNKNOWN_ERROR
      );
      if (code === Result.SUCCESS) {
        const notificationData = safeDeepGet(
          this.props,
          ['getNotificationResult', 'body'],
          {}
        );

        const show = safeDeepGet(notificationData, 'show', false);
        const message = safeDeepGet(notificationData, 'message', '');
        this.setState({ show, message });
        // this.showToast();
        // setTimeout(window.location.reload(), 1000);
        // this.toggle();
      }
    }
    if (
      this.props.updateNotificationResult !== prevProps.updateNotificationResult
    ) {
      // Success create
      const code = safeDeepGet(
        this.props,
        ['updateNotificationResult', 'code'],
        Result.UNKNOWN_ERROR
      );
      if (code === Result.SUCCESS) {
        const notificationData = safeDeepGet(
          this.props,
          ['updateNotificationResult', 'body'],
          {}
        );
        this.showToast('Notification');
        this.toggleNotification();
        this.props.GetNotification();

        // const show = safeDeepGet(notificationData, 'show', false);
        // const message = safeDeepGet(notificationData, 'message', '');
        // this.setState({show, message})
        // this.showToast();
        // setTimeout(window.location.reload(), 1000);
        // this.toggle();
      } else if (code === Result.FAILED) {
        this.showToastFailed('Notification');
        this.props.GetNotification();
      }
    }
  }

  handleAddRow = () => {
    const item = {
      row: '',
      key: '',
      from: '',
      format: '',
      sdefault: '',
      fallback: '',
      condition: '',
    };
    this.setState({
      configDownload: [...this.state.configDownload, item],
    });
  };

  handleRemoveRow = (e, idx) => {
    if (this.state.configDownload.length > 1) {
      this.state.configDownload.splice(idx, 1);
      this.setState({ configDownload: this.state.configDownload });
    }
  };
  showToastFailed(message) {
    var toastType = 'error';

    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      onclick: null,
      showDuration: '300',
      hideDuration: '1000',
      timeOut: '5000',
      extendedTimeOut: '1000',
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut',
    };

    if (toastType === 'info') toastr.info(message);
    else if (toastType === 'warning') toastr.warning(message);
    else if (toastType === 'error') toastr.error(message);
    else toastr.success(message);
  }
  showToastToggle(msg) {
    var toastType = 'success';
    var message = 'Berhasil merubah kondisi ' + msg;

    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      onclick: null,
      showDuration: '300',
      hideDuration: '1000',
      timeOut: '5000',
      extendedTimeOut: '1000',
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut',
    };

    if (toastType === 'info') toastr.info(message);
    else if (toastType === 'warning') toastr.warning(message);
    else if (toastType === 'error') toastr.error(message);
    else toastr.success(message);
  }
  showToastFailedToggle(msg) {
    var toastType = 'error';
    var message = 'Gagal merubah kondisi ' + msg;

    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      onclick: null,
      showDuration: '300',
      hideDuration: '1000',
      timeOut: '5000',
      extendedTimeOut: '1000',
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut',
    };

    if (toastType === 'info') toastr.info(message);
    else if (toastType === 'warning') toastr.warning(message);
    else if (toastType === 'error') toastr.error(message);
    else toastr.success(message);
  }
  showToast(mmm) {
    var toastType = 'success';
    var message = 'Berhasil Tambah ' + mmm;

    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      onclick: null,
      showDuration: '300',
      hideDuration: '1000',
      timeOut: '5000',
      extendedTimeOut: '1000',
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut',
    };

    if (toastType === 'info') toastr.info(message);
    else if (toastType === 'warning') toastr.warning(message);
    else if (toastType === 'error') toastr.error(message);
    else toastr.success(message);
  }
  toggleDetail() {
    this.setState(prevState => ({
      modalDetail: !prevState.modalDetail,
    }));
  }
  handleImportClick = row => {
    this.toggleDetail();
  };
  handleAddProjectHandle = row => {
    this.setState(prevState => ({
      modalProjectHandle: !prevState.modalProjectHandle,
    }));
  };

  handleManualUpdateBalance = data => {
    this.props.ManualUpdateBalance(data);
  };
  handleGraphClick = row => {
    const appId = safeDeepGet(row, 'appid', '');
    this.props.history.replace('/admin/graph/' + appId);
  };
  handleSummaryClick = row => {
    const appId = safeDeepGet(row, 'appid', '');
    this.props.history.replace('/admin/summary/' + appId);
  };
  handleDonloadClick = data => {
    const id = safeDeepGet(data, 'id', '-');
    const arr_data = [];
    for (const i in data) {
      const url = data[i];
      if (i != 'balance') {
        if (i != 'multitenancy_id') {
          if (i != 'commit_point') {
            arr_data.push({ keys: i, url: url.toString() });
          }
        }
      }
    }
    var csv = Papa.unparse(arr_data);

    var csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    var csvURL = null;
    if (navigator.msSaveBlob) {
      csvURL = navigator.msSaveBlob(csvData, 'download.csv');
    } else {
      csvURL = window.URL.createObjectURL(csvData);
    }

    var tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', 'Mapping_URL_Project_' + id + '.csv');
    tempLink.click();
  };
  handleOnChange = e => {
    const file = e.target.files[0];
    if (file.size > 5000) {
      this.setState({ file });
    } else {
      this.setState({ file });
    }
    // let valuesArray =[]
    Papa.parse(e.target.files[0], {
      header: true,
      complete: function (results) {
        const valuesArray = results['data'];
        this.setState({ valuesArray });
        const rowsArray = [];
        // Iterating data to get column name and their values
        results.data.map(d => {
          rowsArray.push(Object.keys(d));
        });
        this.setState({ rowsArray });
      }.bind(this),
    });
  };
  handleOnChangeProduct = e => {
    const file = e.target.files[0];
    this.setState({ file });

    // let valuesArray =[]
    Papa.parse(e.target.files[0], {
      header: true,
      complete: function (results) {
        const productArray = results['data'];
        const updatedproductArray = productArray.filter(d => d.sku !== '');
        this.setState({ productArray: updatedproductArray });
        const productRowsArray = [];
        // Iterating data to get column name and their values
        results.data.map(d => {
          productRowsArray.push(Object.keys(d));
        });
        this.setState({ productRowsArray });
      }.bind(this),
    });
  };
  handleSubmitProduct() {
    const { productArray, application } = this.state;
    const payload = {
      data: productArray,
      application,
    };
    this.setState({ isLoading: true });
    this.props.ImportProduct(payload);
  }
  handleSubmit() {
    const payload = {
      data: this.state.valuesArray,
    };
    this.props.CreateCSV(payload);
    this.setState({ valuesArray: [] });
  }
  handleUserClick(project) {
    this.props.history.push('/admin/user/' + project.appid);
  }
  handleDeviceClick(project) {
    this.props.history.push('/admin/business-point/' + project.appid);
  }
  handleTagClick(project) {
    this.props.history.push('/admin/tags/' + project.appid);
  }
  afterSaveCell(oldValue, newValue, row, column) {
    const dataField = safeDeepGet(column, 'dataField', '');
    const url_toggle_auto = safeDeepGet(row, 'url_toggle_auto_refund', '');
    const url_multi_balance = safeDeepGet(row, 'url_toggle_multi_balance', '');
    const multitenancy = safeDeepGet(row, 'multitenancy', '');
    const app_id = safeDeepGet(row, 'appid', safeDeepGet(row, 'id', ''));

    if (dataField == 'autoRefund') {
      if (url_toggle_auto !== '') {
        const payload = {
          url: url_toggle_auto,
          application_id: '100000' + app_id,
          multitenancy: multitenancy,
          active: newValue,
          key: 'auto_refund',
        };
        this.props.ToogleRefund(payload);
      }
    } else if (dataField == 'multiBalance') {
      const url_cms = safeDeepGet(row, 'url_cms', '');
      const subdomain = url_cms.split('//')[1].split('.')[0];
      const payload = {
        url: 'https://asia-southeast2-iotera-vending-multitenancy.cloudfunctions.net/setMultiBalance',
        application_id: '100000' + app_id,
        multitenancy: multitenancy,
        value: newValue,
        domain: subdomain,
        key: 'multiBalance',
      };
      this.props.ToogleRefund(payload);
    } else if (dataField == 'typeCMS') {
      const url_cms = safeDeepGet(row, 'url_cms', '');
      const subdomain = url_cms.split('//')[1].split('.')[0];
      const payload = {
        url: 'https://asia-southeast2-iotera-vending-multitenancy.cloudfunctions.net/setMultiBalance',
        application_id: '100000' + app_id,
        multitenancy: multitenancy,
        value: newValue, // Tetap menggunakan newValue
        domain: subdomain,
        key: 'typeCMS',
      };
      this.props.ToogleRefund(payload);
    } else if (dataField == 'shareLandlord') {
      const url_cms = safeDeepGet(row, 'url_cms', '');
      const subdomain = url_cms.split('//')[1].split('.')[0];
      const payload = {
        url: 'https://asia-southeast2-iotera-vending-multitenancy.cloudfunctions.net/setMultiBalance',
        application_id: '100000' + app_id,
        multitenancy: multitenancy,
        value: newValue, // Tetap menggunakan newValue
        domain: subdomain,
        key: 'shareLandlord',
      };
      this.props.ToogleRefund(payload);
    }
  }

  render() {
    // const list = safeDeepGet(this.props, ['result', 'body'], []);
    const { list, isLoading, show, message, configDownload, formData } =
      this.state;
    const { SearchBar } = Search;

    const model = {
      show: show,
    };
    const pageOptions = {
      sizePerPage: 100,
      totalSize: list.length, // replace later with size(users),
      custom: true,
    };

    const defaultSorted = [
      {
        dataField: 'email', // if dataField is not match to any column you defined, it will be ignored.
        order: 'asc', // desc or asc
      },
    ];
    const formValues = [
      { keys: 'id', url: ' ' },
      { keys: 'name', url: ' ' },
      { keys: 'url_balance', url: ' ' },
      { keys: 'url_bp_fee', url: ' ' },
      { keys: 'url_business_point', url: ' ' },
      { keys: 'url_call_scheduler', url: ' ' },
      { keys: 'url_cms_detail_chat', url: ' ' },
      { keys: 'url_cms_detail_complaint', url: ' ' },
      { keys: 'url_create_fee', url: ' ' },
      { keys: 'url_create_payout', url: ' ' },
      { keys: 'url_create_tag', url: ' ' },
      { keys: 'url_created_user', url: ' ' },
      { keys: 'url_data_chat', url: ' ' },
      { keys: 'url_delete_fee', url: ' ' },
      { keys: 'url_delete_tags', url: ' ' },
      { keys: 'url_deleted_user', url: ' ' },
      { keys: 'url_detail_transaction', url: ' ' },
      { keys: 'url_get_tag', url: ' ' },
      { keys: 'url_get_user', url: ' ' },
      { keys: 'url_latest_transaction', url: ' ' },
      { keys: 'url_refund_notification', url: ' ' },
      { keys: 'url_serverless_complaint', url: ' ' },
      { keys: 'url_summary', url: ' ' },
      { keys: 'url_summary_device', url: ' ' },
      { keys: 'url_update_time', url: ' ' },
    ];
    const arr_data = formValues;
    const headerKeys = Object.keys(Object.assign({}, ...arr_data));
    const dataheader = {};
    const header = [];
    for (const id in headerKeys) {
      const data = headerKeys[id];
      safeDeepSet(dataheader, [id, 'text'], data);
      safeDeepSet(dataheader, [id, 'dataField'], data);

      // set formatter text in table
      if (data == 'imgUrl') {
        safeDeepSet(dataheader, [id, 'formatter'], (cellContent, row) => (
          <>
            <p className="text-wrap">{row.imgUrl}</p>
          </>
        ));
      }
      if (data == 'description') {
        safeDeepSet(dataheader, [id, 'formatter'], (cellContent, row) => (
          <>
            <p className="text-wrap">{row.description}</p>
          </>
        ));
      }
      header.push(dataheader[id]);
    }

    const headers = [
      {
        label: 'keys',
        key: 'keys',
      },
      {
        label: 'url',
        key: 'url',
      },
    ];
    const separator = ','; //if want csv File using commma change with (',') or something else
    const csvLink = {
      headers: headers,
      data: formValues,
      separator: separator,
      filename: 'Projects.csv',
    };

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Project List | Admin </title>
          </MetaTags>
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Project" breadcrumbItem="List" />
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={this.state.ProjectListColumns}
                      data={list}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={this.state.ProjectListColumns}
                          data={list}
                          search
                        >
                          {toolkitprops => (
                            <React.Fragment>
                              <Row className="mb-2">
                                <Col sm="3">
                                  <div className="search-box ms-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitprops.searchProps}
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col>

                                <Col sm="9" className="text-end">
                                  <div>
                                    <Button
                                      className="btn btn-primary white "
                                      onClick={this.toggleNotification}
                                    >
                                      Add Notification
                                    </Button>{' '}
                                    <Button
                                      className="btn btn-primary white "
                                      onClick={this.handleAddProjectHandle}
                                    >
                                      Add Project Handle
                                    </Button>{' '}
                                    <CSVLink
                                      {...csvLink}
                                      className="btn btn-primary white "
                                    >
                                      Download Template Mapping URL
                                    </CSVLink>{' '}
                                    <Button
                                      className="btn btn-primary white "
                                      onClick={this.handleImportClick}
                                    >
                                      Input CSV
                                    </Button>
                                  </div>
                                  {/* <Row>
                                    <Col sm={9}>
                                      <div className="text-sm-end">
                                        
                                      </div>
                                    </Col>
                                    <Col sm={3}>
                                      <div className="text-sm-end">
                                       
                                    </Col>
                                  </Row> */}
                                </Col>
                              </Row>
                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        'table align-middle table-nowrap table-hover'
                                      }
                                      cellEdit={cellEditFactory({
                                        mode: 'click',
                                        blurToSave: true,
                                        afterSaveCell: this.afterSaveCell,
                                      })}
                                      // striped={false}
                                      responsive
                                      ref={this.node}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                    <Modal
                      size="lg"
                      isOpen={this.state.modalProduct}
                      className={this.props.className}
                    >
                      <ModalHeader toggle={this.toggleProduct} tag="h4">
                        {'Import Product'}
                      </ModalHeader>
                      <ModalBody>
                        <Row className="mb-3">
                          <Col xs="7">
                            <div className="text-sm-center">
                              <input
                                className="form-control"
                                type="file"
                                accept=".csv"
                                id="csvFile"
                                onChange={this.handleOnChangeProduct}
                              ></input>
                            </div>
                          </Col>
                          <Col xs="5">
                            <div className="text-sm-center">
                              {isLoading ? (
                                <button type="button" className="btn btn-dark ">
                                  <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{' '}
                                  Loading
                                </button>
                              ) : (
                                <Button
                                  className="btn btn-primary white "
                                  onClick={this.handleSubmitProduct}
                                >
                                  Import CSV
                                </Button>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </ModalBody>
                    </Modal>
                    <Modal
                      size="lg"
                      isOpen={this.state.modalDetail}
                      className={this.props.className}
                    >
                      <ModalHeader toggle={this.toggleDetail} tag="h4">
                        {'Import RFID'}
                      </ModalHeader>
                      <ModalBody>
                        <Row className="mb-3">
                          <Col xs="7">
                            <div className="text-sm-center">
                              <input
                                className="form-control"
                                type="file"
                                accept=".csv"
                                id="csvFile"
                                onChange={this.handleOnChange}
                              ></input>
                            </div>
                          </Col>
                          <Col xs="5">
                            <div className="text-sm-center">
                              <Button
                                className="btn btn-hamparan white "
                                onClick={this.handleSubmit}
                              >
                                Import CSV
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </ModalBody>
                    </Modal>
                    <Modal
                      size="lg"
                      isOpen={this.state.modalProjectHandle}
                      className={this.props.className}
                    >
                      <ModalHeader
                        toggle={this.handleAddProjectHandle}
                        tag="h4"
                      >
                        {'Add Project'}
                      </ModalHeader>
                      <ModalBody>
                        <AvForm onValidSubmit={this.handleValidProjectHandle}>
                          <Row>
                            <Col xs="12">
                              <Card>
                                <CardBody>
                                  <Row>
                                    <Col sm="12">
                                      <FormGroup className="mb-3 select2-container">
                                        <Label>Name Application :</Label>
                                        <AvField
                                          type="text"
                                          id="name"
                                          name="name"
                                          placeholder="Masukan Nama Aplikasi..."
                                          className="form-control"
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col sm="12">
                                      <FormGroup className="mb-3 select2-container">
                                        <Label>Application ID:</Label>
                                        <AvField
                                          type="text"
                                          id="applicationId"
                                          name="applicationId"
                                          placeholder="Masukan Application id..."
                                          className="form-control"
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col sm="12">
                                      <FormGroup className="mb-3 select2-container">
                                        <AvGroup check>
                                          <AvInput
                                            type="checkbox"
                                            name="multitenancy"
                                          />
                                          <Label check for="multitenancy">
                                            {' '}
                                            Multitenancy
                                          </Label>
                                        </AvGroup>
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col sm="12">
                                      <FormGroup className="mb-3 select2-container">
                                        <Label>Firebase ID:</Label>
                                        <AvField
                                          type="text"
                                          id="id"
                                          name="id"
                                          placeholder="iotera-vending-multitenancy"
                                          className="form-control"
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col sm="2">
                                      <FormGroup className="mb-3 select2-container">
                                        <Label>Url:</Label>
                                        <AvField
                                          type="text"
                                          id="url"
                                          name="url"
                                          placeholder="iotera-vending-multitenancy"
                                          className="form-control"
                                        />
                                      </FormGroup>
                                    </Col>
                                    <Col sm="10">
                                      <Label>..</Label>
                                      <FormGroup className="mb-3 select2-container">
                                        <AvField
                                          type="text"
                                          id="ffa"
                                          name="ffa"
                                          disabled={true}
                                          value="smartvending.cloud"
                                          className="form-control"
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs="12">
                              <div className="d-flex flex-wrap gap-2 float-end mb-4">
                                <Link
                                  className="btn btn-secondary"
                                  role="button"
                                  onClick={this.togglePrice}
                                  to="#"
                                >
                                  Batal
                                </Link>{' '}
                                <Button type="submit" color="primary">
                                  Simpan
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </AvForm>
                      </ModalBody>
                    </Modal>
                    {/* Modal Price */}
                    <Modal
                      size="lg"
                      isOpen={this.state.modalPrice}
                      className={this.props.className}
                    >
                      <ModalHeader toggle={this.togglePrice} tag="h4">
                        {'Subscription Price ' + this.state.applicationID}
                      </ModalHeader>
                      <ModalBody>
                        <AvForm onValidSubmit={this.handleValidSubmitPrice}>
                          <Row>
                            <Col xs="12">
                              <Card>
                                <CardBody>
                                  <Row>
                                    <Col sm="12">
                                      <FormGroup className="mb-3 select2-container">
                                        <Label>Price Subscription:</Label>
                                        <AvField
                                          type="number"
                                          id="price_subs"
                                          name="price_subs"
                                          value={
                                            this.state.price_subs || 1000000
                                          }
                                          placeholder="Masukan harga Subscription..."
                                          className="form-control"
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs="12">
                              <div className="d-flex flex-wrap gap-2 float-end mb-4">
                                <Link
                                  className="btn btn-secondary"
                                  role="button"
                                  onClick={this.togglePrice}
                                  to="#"
                                >
                                  Batal
                                </Link>{' '}
                                <Button type="submit" color="primary">
                                  Simpan
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </AvForm>
                      </ModalBody>
                    </Modal>
                    {/* Modal Notification */}
                    <Modal
                      size="lg"
                      isOpen={this.state.modalNotification}
                      className={this.props.className}
                    >
                      <ModalHeader toggle={this.toggleNotification} tag="h4">
                        {'Push Notification'}
                      </ModalHeader>
                      <ModalBody>
                        <AvForm
                          onValidSubmit={this.handleValidSubmitNotification}
                          model={model}
                        >
                          <Row>
                            <Col xs="12">
                              <Card>
                                <CardBody>
                                  <Row>
                                    <Col sm="12">
                                      <FormGroup className="mb-3 select2-container">
                                        <Label>Message Notification</Label>
                                        <AvField
                                          type="textarea"
                                          rows="5"
                                          id="message"
                                          name="message"
                                          validate={{
                                            maxLength: {
                                              value: 300,
                                              errorMessage:
                                                'Maksimal 300 karakter!',
                                            },
                                          }}
                                          value={message || ''}
                                          placeholder="Masukan Text Notifikasi.."
                                          className="form-control"
                                        />
                                        <AvInput
                                          checked={show}
                                          type="checkbox"
                                          name="show"
                                        />{' '}
                                        Active
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs="12">
                              <div className="d-flex flex-wrap gap-2 float-end mb-4">
                                <Link
                                  className="btn btn-secondary"
                                  role="button"
                                  onClick={this.toggleNotification}
                                  to="#"
                                >
                                  Batal
                                </Link>{' '}
                                <Button type="submit" color="primary">
                                  Simpan
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </AvForm>
                      </ModalBody>
                    </Modal>
                    <Modal
                      isOpen={this.state.modalFlag}
                      className={this.props.className}
                    >
                      <ModalHeader toggle={this.toggleFlag} tag="h4">
                        {'Setting'}
                      </ModalHeader>
                      <ModalBody>
                        <AvForm onValidSubmit={this.handleValidSubmit}>
                          <Row className="mb-3">
                            {/* KIRI */}
                            <Col md={6}>
                              <AvGroup check>
                                <Label check>
                                  <Input
                                    type="checkbox"
                                    name="autoRefund"
                                    checked={formData.autoRefund}
                                    onChange={e =>
                                      this.setState({
                                        formData: {
                                          ...formData,
                                          autoRefund: e.target.checked,
                                        },
                                      })
                                    }
                                  />{' '}
                                  Auto Refund
                                </Label>
                              </AvGroup>

                              <AvGroup check>
                                <Label check>
                                  <Input
                                    type="checkbox"
                                    name="multiBalance"
                                    checked={formData.multiBalance}
                                    onChange={e =>
                                      this.setState({
                                        formData: {
                                          ...formData,
                                          multiBalance: e.target.checked,
                                        },
                                      })
                                    }
                                  />{' '}
                                  Multi Balance
                                </Label>
                              </AvGroup>
                            </Col>

                            {/* KANAN */}
                            <Col md={6}>
                              <AvGroup check>
                                <Label check>
                                  <Input
                                    type="checkbox"
                                    name="shareLandlord"
                                    checked={formData.shareLandlord}
                                    onChange={e =>
                                      this.setState({
                                        formData: {
                                          ...formData,
                                          shareLandlord: e.target.checked,
                                        },
                                      })
                                    }
                                  />{' '}
                                  Share Landlord
                                </Label>
                              </AvGroup>
                              <AvGroup check>
                                <Label check>
                                  <Input
                                    type="checkbox"
                                    name="withHours"
                                    checked={formData.withHours}
                                    onChange={e =>
                                      this.setState({
                                        formData: {
                                          ...formData,
                                          withHours: e.target.checked,
                                        },
                                      })
                                    }
                                  />{' '}
                                  Filter With Hours
                                </Label>
                              </AvGroup>
                            </Col>
                          </Row>

                          <AvField
                            type="select"
                            name="typeCMS"
                            label="Type CMS"
                            value={formData.typeCMS}
                            onChange={e =>
                              this.setState({
                                formData: {
                                  ...formData,
                                  typeCMS: e.target.value,
                                },
                              })
                            }
                          >
                            <option value="">Not Selected</option>
                            <option value="subscription">Subscription</option>
                            <option value="share_revenue">Share Revenue</option>
                          </AvField>

                          <div className="d-flex justify-content-end mt-3">
                            <Button
                              variant="secondary"
                              onClick={this.toggleFlag}
                              className="me-2"
                            >
                              Cancel
                            </Button>
                            <Button
                              type="submit"
                              color="primary"
                              variant="primary"
                            >
                              Submit
                            </Button>
                          </div>
                        </AvForm>
                      </ModalBody>
                    </Modal>

                    <Modal
                      size="xl"
                      isOpen={this.state.modalConfig}
                      className={this.props.className}
                    >
                      <ModalHeader toggle={this.toggleConfig} tag="h4">
                        Configuration Download Data CMS
                      </ModalHeader>
                      <ModalBody>
                        <FormGroup className="mb-3">
                          {/* Trigger to open Sample JSON Modal */}
                          <Label
                            style={{
                              cursor: 'pointer',
                              color: '#007bff',
                              textDecoration: 'underline',
                            }}
                            onClick={() =>
                              this.setState({ showJsonModal: true })
                            }
                          >
                            Example Table
                          </Label>
                          <table>
                            <tbody>
                              {configDownload.map((item, idx) => (
                                <tr id={'addr' + idx} key={idx}>
                                  <td>
                                    <Form
                                      className="repeater mt-3"
                                      encType="multipart/form-data"
                                    >
                                      <div data-repeater-list="group-a">
                                        <Row data-repeater-item>
                                          <Col xl="3" className="mb-3">
                                            <Label htmlFor="name">
                                              Table Name
                                            </Label>
                                            <Input
                                              type="text"
                                              id="row"
                                              name="row"
                                              defaultValue={item.row}
                                              placeholder="Masukan Nama Table"
                                              onChange={e =>
                                                this.handleInputChange(e, idx)
                                              }
                                            />
                                          </Col>

                                          <Col xl="3" className="mb-3">
                                            <Label htmlFor="text">
                                              Key Table
                                            </Label>
                                            <Input
                                              type="text"
                                              id="key"
                                              name="key"
                                              defaultValue={item.key}
                                              placeholder="Masukan nama key data"
                                              onChange={e =>
                                                this.handleInputChange(e, idx)
                                              }
                                            />
                                          </Col>

                                          <Col xl="3" className="mb-3">
                                            <Label htmlFor="text">
                                              Table Data
                                            </Label>
                                            <Input
                                              type="text"
                                              id="from"
                                              name="from"
                                              defaultValue={item.from}
                                              placeholder="Masukan tabel data"
                                              onChange={e =>
                                                this.handleInputChange(e, idx)
                                              }
                                            />
                                          </Col>
                                          <Col xl="3" className="mb-3">
                                            <Label htmlFor="text">
                                              Default Data
                                            </Label>
                                            <Input
                                              type="text"
                                              id="default"
                                              name="default"
                                              defaultValue={item.default}
                                              placeholder="Masukan default data jika tidak ada"
                                              onChange={e =>
                                                this.handleInputChange(e, idx)
                                              }
                                            />
                                          </Col>
                                          <Col xl="3" className="mb-3">
                                            <Label htmlFor="text">
                                              Condition
                                            </Label>
                                            <Input
                                              type="text"
                                              id="condition"
                                              name="condition"
                                              defaultValue={item.condition}
                                              placeholder="Masukan Kondisi data yang di butuhkan"
                                              onChange={e =>
                                                this.handleInputChange(e, idx)
                                              }
                                            />
                                          </Col>
                                          <Col xl="3" className="mb-3">
                                            <Label htmlFor="text">
                                              Data Fallback
                                            </Label>
                                            <Input
                                              type="text"
                                              id="fallback"
                                              name="fallback"
                                              defaultValue={item.fallback}
                                              placeholder="Masukan data yang di ambil selain dari tabel data"
                                              onChange={e =>
                                                this.handleInputChange(e, idx)
                                              }
                                            />
                                          </Col>

                                          <Col xl="3" className="mb-3">
                                            <Label htmlFor="text">
                                              Format data
                                            </Label>
                                            <Input
                                              type="text"
                                              id="format"
                                              name="format"
                                              defaultValue={item.format}
                                              placeholder="Masukan format data"
                                              onChange={e =>
                                                this.handleInputChange(e, idx)
                                              }
                                            />
                                          </Col>
                                          <Col
                                            xl="2"
                                            className="form-group align-self-center"
                                          >
                                            {configDownload.length > 1 ? (
                                              <Button
                                                onClick={e =>
                                                  this.handleRemoveRow(e, idx)
                                                }
                                                color="primary"
                                                className="mt-3"
                                                style={{ width: '100%' }}
                                              >
                                                Delete
                                              </Button>
                                            ) : (
                                              <></>
                                            )}
                                          </Col>
                                        </Row>
                                      </div>
                                    </Form>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <Button
                            onClick={this.handleAddRow}
                            color="success"
                            className="mt-3 mt-lg-0"
                          >
                            Add Config{' '}
                          </Button>{' '}
                        </FormGroup>
                      </ModalBody>
                      <ModalFooter>
                        <Button
                          onClick={this.toggleConfig}
                          color="danger"
                          className="mt-3 mt-lg-0"
                        >
                          Cancle{' '}
                        </Button>{' '}
                        <Button
                          onClick={this.handleConfigSubmit}
                          color="primary"
                          className="mt-3 mt-lg-0"
                        >
                          Submit{' '}
                        </Button>{' '}
                      </ModalFooter>
                    </Modal>

                    <SampleJsonModal
                      isOpen={this.state.showJsonModal}
                      toggle={() => this.setState({ showJsonModal: false })}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  test: state,
  result: safeDeepGet(state, ['Mapping', 'list'], {}),
  balance_result: safeDeepGet(state, ['Mapping', 'list_balance'], {}),
  createResult: safeDeepGet(state, ['Project', 'create'], {}),
  productResult: safeDeepGet(state, ['Project', 'importProduct'], {}),
  getNotificationResult: safeDeepGet(state, ['Project', 'getNotification'], {}),
  updateNotificationResult: safeDeepGet(
    state,
    ['Project', 'updateNotification'],
    {}
  ),
  loading: safeDeepGet(state, ['Mapping', 'loading'], {}),
  updateResult: safeDeepGet(state, ['Mapping', 'update'], {}),
  setPriceResult: safeDeepGet(state, ['BpFee', 'set_price_subs'], {}),
  toggleResult: safeDeepGet(state, ['Mapping', 'toggleRefund'], {}),
  toggleMultiResult: safeDeepGet(state, ['Mapping', 'toggleMultiBalance'], {}),
  manualResult: safeDeepGet(state, ['Mapping', 'manualUpdate'], {}),
  addResult: safeDeepGet(state, ['Mapping', 'addProjectHandle'], {}),
  getDownloadResult: safeDeepGet(state, ['Mapping', 'getDownloadConfig'], {}),
  setDownloadResult: safeDeepGet(state, ['Mapping', 'setDownloadConfig'], {}),
});

const mapDispatchToProps = dispatch => ({
  MappList: () => dispatch(list()),
  BalanceList: () => dispatch(list_balance()),
  ToogleRefund: payload => dispatch(toggleRefund(payload)),
  ToggleMulti: payload => dispatch(toggleMultiBalance(payload)),
  ManualUpdateBalance: payload => dispatch(manualUpdate(payload)),
  // UpdateRefiller: payload => dispatch(update(payload)),
  // DeleteUser: payload => dispatch(delete_(payload)),
  CreateCSV: payload => dispatch(create(payload)),
  ImportProduct: payload => dispatch(importProduct(payload)),
  UpdatePrice: payload => dispatch(set_price_subs(payload)),
  AddProjectHandle: payload => dispatch(addProjectHandle(payload)),
  GetNotification: () => dispatch(getNotification()),
  PushNotification: payload => dispatch(updateNotification(payload)),
  GetDownload: payload => dispatch(getDownloadConfig(payload)),
  SetDownload: payload => dispatch(setDownloadConfig(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectList);
